import { Map } from 'immutable';
import simpleReducer from '../common/utils/simple-reducer';
import { CHANGE_FIELD } from '../schema-form/action-types';

function isFutureDate(isoStr) {
  return new Date(isoStr).getTime() > Date.now();
}

export default simpleReducer(Map(), {
  [CHANGE_FIELD](state, { meta, payload }) {
    // If we enabled a post with a future enabled date set the enabled date to now
    if (meta.path[0] === '_enabled') {
      const enabledAt = state.getIn(['data', '_enabledAt']);
      if (payload && isFutureDate(enabledAt)) {
        return state.setIn(['data', '_enabledAt'], new Date().toISOString());
      }
    }

    // If we set a future enabled date disabled the content item
    if (meta.path[0] === '_enabledAt') {
      const enabled = state.getIn(['data', '_enabled']);
      if (enabled && isFutureDate(payload)) {
        return state.setIn(['data', '_enabled'], false);
      }
    }

    return state;
  }
});
